import apiClient from "@/src/services/api/axios";
import { useMutation } from "@tanstack/react-query";

type UploadFileInput = {
  uri: string;
  fileName?: string;
  mimeType?: string;
  moduleName?: number;
};

const getPresignedUrl = async (fileName: string) => {
  const response = await apiClient.post(
    "/uds/v1/Files/GetPreSignedUrlForUpload",
    {
      name: fileName,
      projectKey: process.env.EXPO_PUBLIC_X_BLOCKS_KEY,
      configurationName: "Default",
      accessModifier: "Public",
      metaData: "",
      parentDirectoryId: process.env.EXPO_PUBLIC_PARENT_DIRECTORY_ID,
      tags: "",
      moduleName: 3,
    },
  );
  return response.data;
};

const uploadToBlob = async (
  uploadUrl: string,
  uri: string,
  mimeType?: string,
) => {
  const response = await fetch(uri);
  const blob = await response.blob();
  await fetch(uploadUrl, {
    method: "PUT",
    body: blob,
    headers: {
      "Content-Type": mimeType ?? "",
      "x-ms-blob-type": "Blockblob",
    },
  });
};

export const uploadMetadata = async (
  fileName: string,
  fileStorageId: string,
) => {
  const response = await apiClient.post(
    "/uds/v1/Files/UploadFile",
    {
      upload: [
        {
          artifactName: fileName,
          description: `Uploaded file: ${fileName}`,
          parentId: process.env.EXPO_PUBLIC_PARENT_DIRECTORY_ID,
          tags: [],
          metaData: {},
          organizationId: "",
          fileStorageId,
          configurationName: "Azure",
        },
      ],
      projectKey: process.env.EXPO_PUBLIC_X_BLOCKS_KEY,
    },
    {
      headers: {
        "x-blocks-key": process.env.EXPO_PUBLIC_X_BLOCKS_KEY,
      },
    },
  );
  return response.data;
};

export const useUploadFile = () => {
  return useMutation({
    mutationFn: async ({ uri, fileName, mimeType }: UploadFileInput) => {
      const resolvedFileName = fileName ?? `upload_${Date.now()}`;
      const { uploadUrl, fileId } = await getPresignedUrl(resolvedFileName);
      await uploadToBlob(uploadUrl, uri, mimeType);
      //await uploadMetadata(resolvedFileName, fileId);
      return uploadUrl.split("?")[0];
    },
  });
};
